/** Derive a human-friendly service state from WorkerStatus. */

import type { WorkerStatus } from './types';

export type ServiceState = 'connected' | 'paused' | 'unhealthy' | 'offline' | 'unknown';

/**
 * Derive the service state from a WorkerStatus response.
 * @param status  The WorkerStatus data (undefined if not yet fetched).
 * @param isError Whether the status fetch itself failed.
 */
export function deriveServiceState(
  status: WorkerStatus | undefined,
  isError: boolean,
): ServiceState {
  if (isError) return 'offline';
  if (!status) return 'unknown';
  if (status.is_paused_effective) return 'paused';
  const loops = status.loops ? Object.values(status.loops) : [];
  if (loops.some((s) => s === 'error' || s === 'crashed')) return 'unhealthy';
  if (status.queue_size > 500) return 'unhealthy';
  return 'connected';
}
